<template>
  <aside id="sk-sidebar-accordion" class="support-sidebar">
    <ul class="support-sidebar__categories">
      <li 
        class="support-sidebar__category control"
        :class="categoryClass(categoryIndex)"
        v-for="(category, categoryIndex) in faqLinks"
        :key="categoryIndex"
        @click="categoryClicked(categoryIndex)"
      >
        <p>{{ category.name }}</p>
        <ul 
          class="support-sidebar__articles target"
          :style="childStyle(categoryIndex)"
        >
          <li
            :class="linkClass(link.isActive)"
            v-for="(link, linkIndex) in category.links"
            :key="linkIndex"
          >
            <a :href="link.url" v-html="link.title"></a>
          </li>
        </ul>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  props: {
    faqLinks: {
      type: Array,
      required: true,
    },
  },
  data(){
    return {
      activeCategory: -1,
    };
  },
  methods: {
    linkClass(isActive){
      const baseClass = 'support-sidebar__article';
      const modifier = isActive ? '--active' : '';
      return baseClass + modifier;
    },
    categoryClass(categoryIndex){
      return {
        active: categoryIndex === this.activeCategory
      };
    },
    categoryClicked(categoryIndex){
      this.activeCategory = this.activeCategory !== categoryIndex ? categoryIndex : -1;
    },
    childStyle(categoryIndex){
      if (categoryIndex === this.activeCategory) {
        const childLength = this.faqLinks[categoryIndex].links.length;
        const maxChildItemHeight = 56;
        const maxHeight = childLength * maxChildItemHeight;
        return {
          'max-height': `${maxHeight}px`,
          transition: 'max-height 0.5s'
        };
      }
      return {
        'max-height': '0px'
      };
    },
  }
};
</script>